module.exports = __webpack_public_path__ + "static/SquareSerif-Light-webfont-588f916b16e26135ddb3b46093cf184e.ttf";